import type { Tour } from 'nextstepjs';
import { Puzzle, Search, Settings, CheckCircle } from 'lucide-react';

/**
 * Plugin Installation Tour
 * Guides users through installing and configuring a plugin
 */
export function getPluginInstallationTour(pluginName?: string): Tour {
  const displayName = pluginName || 'your plugin';

  return {
    tour: 'plugin-installation',
    steps: [
      {
        icon: <Puzzle className="h-5 w-5" />,
        title: `Let's install ${displayName}`,
        content: (
          <div className="space-y-2">
            <p>We'll guide you through installing and configuring this plugin.</p>
            <p className="text-muted-foreground text-sm">It's quick and easy!</p>
          </div>
        ),
        selector: '#plugin-marketplace-search',
        side: 'bottom',
        showControls: true,
        showSkip: true,
        pointerPadding: 10,
        pointerRadius: 8,
      },
      {
        icon: <Search className="h-5 w-5" />,
        title: 'Browse available plugins',
        content: (
          <div className="space-y-2">
            <p>Browse our marketplace to find the perfect plugins for your store.</p>
            <p className="text-muted-foreground text-sm">Each plugin is designed to boost conversions!</p>
          </div>
        ),
        selector: '#plugin-grid',
        side: 'top',
        showControls: true,
        showSkip: true,
        pointerPadding: 10,
        pointerRadius: 8,
      },
      {
        icon: <Settings className="h-5 w-5" />,
        title: 'Configure your plugin',
        content: (
          <div className="space-y-2">
            <p>Choose a preset or customize settings to match your needs.</p>
            <p className="text-muted-foreground text-sm">Don't worry, you can change these later!</p>
          </div>
        ),
        selector: '#plugin-config-form',
        side: 'left',
        showControls: true,
        showSkip: true,
        pointerPadding: 10,
        pointerRadius: 8,
      },
      {
        icon: <CheckCircle className="h-5 w-5" />,
        title: 'Install complete!',
        content: (
          <div className="space-y-2">
            <p>Your plugin is ready to use!</p>
            <p className="text-muted-foreground text-sm">You can manage it from the Plugins page anytime.</p>
          </div>
        ),
        side: 'top',
        showControls: true,
        showSkip: false,
        pointerPadding: 10,
        pointerRadius: 8,
      },
    ],
  };
}

export const pluginInstallationTour = getPluginInstallationTour();
